import React, { Component } from 'react'
import ActivityOneContent from './activityOneContent'

class ActivityOneScreen extends Component {
  render() {
    return (
      <div>
        <ActivityOneContent {...this.props} />
      </div>
    )
  }
}

export default ActivityOneScreen


// WEBPACK FOOTER //
// ./src/modules/activity/components/index.js